import { SET_PARAM } from '../types'

export const setExportDocumentParam = (param) => {

  if(Object.values(param)[0] === 'Todos'){
    param[Object.keys(param)[0]] = -1
  }

  return dispatch => dispatch(setParam(param))
}

const setParam = (param) => ({
  type: SET_PARAM,
  param
})
